export const otherProductMasterEndpoints = (builder) => ({
    getOtherProductMasterList: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                searchValue,
                sortField,
                sortOrder,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (searchValue) params.searchValue = searchValue;
            if (sortField) params.sortField = sortField;
            if (sortOrder) params.sortOrder = sortOrder;

            return {
                url: '/OtherProduct/OtherProductMaster',
                method: 'POST',
                body: { TObject: params },
            };
        },
        providesTags: ['OtherProductMaster'],
    }),

    getOtherProductMasterById: builder.query({
        query: (id) => `/OtherProduct/get-other-product/${id}`,
        providesTags: (result, error, id) => [{ type: 'OtherProductMaster', id }],
    }),

    saveOtherProductMaster: builder.mutation({
        query: (data) => ({
            url: '/OtherProduct/SaveOtherProductMaster',
            method: 'POST',
            body: { TObject: data },
        }),
        invalidatesTags: ['OtherProductMaster'],
    }),

    deleteOtherProductMaster: builder.mutation({
        query: (id) => ({
            url: `/OtherProduct/delete-other-product/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['OtherProductMaster'],
    }),

    // Aliases for compatibility
    getOtherProducts: builder.query({
        query: (params) => ({
            url: '/OtherProduct/OtherProductMaster',
            method: 'POST',
            body: { TObject: params },
        }),
        providesTags: ['OtherProductMaster'],
    }),

    getOtherProductById: builder.query({
        query: (id) => `/OtherProduct/get-other-product/${id}`,
        providesTags: (result, error, id) => [{ type: 'OtherProductMaster', id }],
    }),

    deleteOtherProduct: builder.mutation({
        query: (id) => ({
            url: `/OtherProduct/delete-other-product/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['OtherProductMaster'],
    }),
});
